/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import 'typeface-roboto';
import UsrAlamatLengkap from '../../container/UsrAlamatLengkap/UsrAlamatLengkap';
import UsrLokasiPengiriman from '../../container/UsrLokasiPengiriman/UsrLokasiPengiriman';
import UsrRealname from '../../component/OlsRow/UsrRealname';
import UsrChangePassword from '../../component/OlsRow/UsrChangePassword';
import UsrWhatsApp from '../../component/OlsRow/UsrWhatsApp';
import UsrLogout from '../../component/OlsRow/UsrLogout';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';

let isMounted = false;

const useStyles = (theme) => ({
  appBarWrapper: {
    backgroundColor: 'white',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
  },
  appBarTitle: {
    position: 'relative',
    display: 'block',
    fontWeight: 'bold',
    marginLeft: 0,
    width: '100%',
  },
  appToolbar: {
    height: 62,
    minHeight: 62,
    maxHeight: 62,
  },
  appBarCart: {
    display: 'flex',
  },
  topWrapper: {
    backgroundColor: 'white',
    height: '50px',
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 62,
    left: 'auto',
    right: 'auto',
    zIndex: '1099',
  },
  content: {
    marginTop: 0,
    marginBottom: 60,
    padding: 4,
    display: 'block',
    minHeight: 1000,
  },
  itemWrapper: {
    marginTop: 0,
    padding: 0,
    display: 'block',
    width: '100%',
  },
  listStyle: {
    width: '100%',
    backgroundColor: 'white',
  },
  cardWrapper: {
    marginBottom: 5,
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
});

// const uinfo = {
//   usr_uxid: '1234',
//   usr_realname: 'Wianto',
//   usr_email: 'wianto@gmail.com',
//   usr_whatsapp: '0812345678',
//   usr_avatar: '',
//   usr_address1: 'Desa Gentawangi RT.01/05',
//   usr_address2: 'Jatilawang',
//   usr_address3: 'Banyumas',
//   usr_address4: '53174',
//   usr_address5: '',
//   usr_province_id: '123',
//   usr_province_name: 'JAWA TENGAH',
//   usr_city_id: '123',
//   usr_city_name: 'BANYUMAS',
//   usr_city_type: 'k',
//   usr_subdistrict_id: 's',
//   usr_subdistrict_name: 'JATILAWANG',
// };

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usr_info: ls.get('usr_info') || {},
      loading: false,
    };
  }

  componentDidMount() {
    isMounted = true;
    this.usrInfoGet();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    isMounted = false;
  }

  usrInfoGet = () => {
    if (isMounted) {
      this.setState({ loading: true });
      axios.post('https://eqiozmart.com/olsapi/acc/app_usr_info/').then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          } else {
            this.setState({ usr_info: false });
            ls.set('usr_info', this.state.usr_info);
            this.props.history.push('/login');
          }
        }
      });
    }
  }

  handleAddressChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('usr_realname', dt.usr_realname);
      formdata.append('usr_address1', dt.usr_address1);
      formdata.append('usr_address2', dt.usr_address2);
      formdata.append('usr_address3', dt.usr_address3);
      formdata.append('usr_address4', dt.usr_address4);
      formdata.append('usr_address5', dt.usr_address5);
      axios.post('https://eqiozmart.com/olsapi/acc/app_address_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          }
        }
      });
    }
  }

  handleLocationChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('usr_province_id', dt.usr_province_id);
      formdata.append('usr_province_name', dt.usr_province_name);
      formdata.append('usr_city_id', dt.usr_city_id);
      formdata.append('usr_city_name', dt.usr_city_name);
      formdata.append('usr_city_type', dt.usr_city_type);
      formdata.append('usr_subdistrict_id', dt.usr_subdistrict_id);
      formdata.append('usr_subdistrict_name', dt.usr_subdistrict_name);
      axios.post('https://eqiozmart.com/olsapi/acc/app_location_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          }
        }
      });
    }
  }

  handleWhatsAppChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('usr_whatsapp', dt.usr_whatsapp);
      axios.post('https://eqiozmart.com/olsapi/acc/app_whatsapp_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          }
        }
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.appBarWrapper}>
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.appToolbar}>
              <Typography className={classes.appBarTitle} variant="h6" noWrap>
                Akun
              </Typography>
            </Toolbar>
            <div style={{ marginBottom: -5, height: 5 }}>
              <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
            </div>
          </AppBar>
        </div>
        <div style={(!_.isString(this.state.usr_info.usr_realname)) ? { display: 'none' } : {}}>
          <div className={classes.content}>
            <UsrRealname data={this.state.usr_info} />
            <UsrAlamatLengkap data={this.state.usr_info} onChange={this.handleAddressChange} />
            <UsrLokasiPengiriman data={this.state.usr_info} onChange={this.handleLocationChange} />
            <UsrWhatsApp data={this.state.usr_info} onChange={this.handleWhatsAppChange} />
            <UsrChangePassword />
            <UsrLogout />
          </div>
        </div>
        <OlsBottomNav value="akun" />
      </div>
    );
  }
}

export default withStyles(useStyles)(Account);
